import { render } from "./TabUsecase.vue?vue&type=template&id=a56d60a0"
import script from "./TabUsecase.vue?vue&type=script&lang=js"
export * from "./TabUsecase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__